import React from 'react'

function Errorpage() {
  return (
    <div>Error page not found</div>
  )
}

export default Errorpage